export const ROLE_PROTECTION_CONDITIONS = {
  ALL: "all",
  ANY: "any",
};
